
/* injects from baggage-loader */

'use strict';

export default class AccountHomeController {

	constructor($log, Parse) {
		'ngInject';

		this.$log = $log;
		this.Parse = Parse;

	}

	$onInit() {

		this.$log.log(this.stats);

		this.widgets = [{
			label: `Donation${this.stats.count === 1 ? '' : 's'} Made`,
			icon: 'fa-handshake-o',
			gradient: 'widget-0',
			data: this.stats.count
		}, {
			label: 'Total Dollars Donated',
			icon: 'fa-usd',	// 'fa-bank'
			gradient: 'widget-1',
			data: `$${this.stats.dollar_amount}`
		}];

		// TODO: fix error here when project donated to goes offline
		// Fetch projects
		this.Parse.Object.fetchAllWithInclude(this.stats.projects, ['header_media'])
			.then(projects => {
				this.projects = projects;
				this.$log.log(projects)
			})
			.catch(err => {
				this.$log.log('Failed to load projects')
			})

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/home/account.home.controller.js